export default {
  EUR: 'en-DE',
  GBP: 'en-GB',
  DKK: 'da-DK',
  NOK: 'no-NO',
  SEK: 'sv-SE',
  USD: 'en-US'
}
